export default "__VITE_ASSET__q05L$ns6__"